export default "__VITE_ASSET__BlVkMgCH__"